module.exports = __webpack_public_path__ + "static/3-a103e2aff64d9a9c2bdd126b03962131.jpg";